import {useEffect} from 'react'

const useTitle = (title)=>{
    useEffect(()=>{
        document.title = title + " | Ceppo Trekking";
    }, [title])
}

export default useTitle;